import {doHttpRequest} from "../util/NetUtil";

export const net_registrationCreate = (payload, handler, errorHandler) => {

    doHttpRequest(
        "/registration/create",
        payload,
        handler,
        errorHandler
    );
}

export const net_registrationValidate = (email, handler, errorHandler) => {

    doHttpRequest(
        "/registration/validate?email=" + email,
        null,
        handler,
        errorHandler,
        "GET"
    );
}

